<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		ok-title="Cerrar"
		title="Importar"
		static
		id="modal-import-view"
		size="lg"
		body-class="position-static"
		>

		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-row>
			<b-form-group class="col-md-6" label="Archivo XLS">
				<input type="file" id="file" ref="file" @change="handleFileUpload()"/>
			</b-form-group>
			<b-form-group class="col-md-6 pt-3 mb-3">
				<b-button variant="success" class="mr-2" @click="submitFile()"><md-icon icon="library_add"/> Subir e insertar datos</b-button>
			</b-form-group>
		</b-row>
		<hr>
		<b-row>
			<b-col class="col-md-12 content-log">
				<div class="console p-3" label="Resultados" v-if="importResult != ''" v-html="importResult"></div>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import api from '../../../api.js'

export default {
	methods: {
		handleFileUpload(){
			this.file = this.$refs.file.files[0];
			this.importResult = "";
		},
		submitFile(){
			this.loading = true;
			let formData = new FormData();
			formData.append('file', this.file);
			api(this).post(`/importxls`,
			formData,
			{
				timeout: 1000 * 60 * 2, //2 minutes
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
			).then((res) => {
				this.importResult = res.data.result;
				this.loading = false
			}).catch(error => {
				this.$root.handleRequestError(error)
				this.loading = false
			});
		},
	},
	props: {
	},
	components: {  },
	data(){
		return {
			file: '',
			importResult: '',
			loading:false,
		}
	},
	computed:{
	},
	mounted(){
	},
	watch:{
	}
}
</script>

<style lang="css" scoped>
.console {
	/* font-family: monospace; */
	border: 1px solid gray;
	color: rgb(100, 100, 100);
	border-radius: 6px;
	background-color: rgb(241, 241, 241);
}
</style>
